module.exports = __webpack_public_path__ + "static/media/Ad_Tollington.9d18460d.jpg";